// extracted by mini-css-extract-plugin
module.exports = {"centerHorizontally":"Loader_centerHorizontally__3YkyP","loader":"Loader_loader__TLVE4","one":"Loader_one__1MxhJ","two":"Loader_two__2rr24","three":"Loader_three__27iY-"};